import { GroupsRoute } from '@/system-modules/groups/v1/api/GroupsRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { IMember } from '@/contracts/system-modules/groups/IMember'

export class GetMembersRoute extends GroupsRoute<null, IMember[]> {
  constructor(private readonly groupUuid: string) {
    super()
  }

  type(): EnumRouteType {
    return EnumRouteType.GET
  }

  url(): string {
    return '/api/system/v1/groups/' + this.groupUuid + '/members'
  }

  /** Без сервера состав пуст */
  offline(): Promise<ApiResponse<IMember[]>> {
    return Promise.resolve(new ApiResponse({ success: true, data: [] }))
  }
}
